var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.0909C13.3636 13.0909 14.5229 12.6138 15.4778 11.6596C16.4327 10.7055 16.9098 9.54618 16.9091 8.18182C16.9091 6.81818 16.432 5.65927 15.4778 4.70509C14.5236 3.75091 13.3644 3.27345 12 3.27273C10.6364 3.27273 9.47745 3.75018 8.52327 4.70509C7.56909 5.66 7.09164 6.81891 7.09091 8.18182C7.09091 9.54545 7.56836 10.7047 8.52327 11.6596C9.47818 12.6145 10.6371 13.0916 12 13.0909ZM12 11.1273C11.1818 11.1273 10.4865 10.8407 9.91418 10.2676C9.34182 9.69455 9.05527 8.99927 9.05455 8.18182C9.05455 7.36364 9.34109 6.66836 9.91418 6.096C10.4873 5.52364 11.1825 5.23709 12 5.23636C12.8182 5.23636 13.5138 5.52291 14.0869 6.096C14.66 6.66909 14.9462 7.36436 14.9455 8.18182C14.9455 9 14.6593 9.69564 14.0869 10.2687C13.5145 10.8418 12.8189 11.128 12 11.1273ZM12 16.3636C9.34546 16.3636 6.92727 15.6229 4.74545 14.1415C2.56364 12.66 0.981818 10.6735 0 8.18182C0.981818 5.69091 2.56364 3.70473 4.74545 2.22327C6.92727 0.741818 9.34546 0.000727273 12 0C14.6545 0 17.0727 0.741091 19.2545 2.22327C21.4364 3.70545 23.0182 5.69164 24 8.18182C23.0182 10.6727 21.4364 12.6593 19.2545 14.1415C17.0727 15.6236 14.6545 16.3644 12 16.3636Z",
    fill: "#3C3C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye-icon.9374d7ce3407c35e87fbf48e97fddea8.svg";
export { ForwardRef as ReactComponent };